<div class="flex items-center justify-center">
  <div class="md:basis-3xl md:bg-white md:rounded-lg md:shadow-xl md:p-8">

    <h1 class="text-xl font-bold mb-8">Modulo di richiesta</h1>

    <form [formGroup]="requestForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6 form">
      <div>
        <label for="name">Nome</label>
        <input id="name" readonly type="text" formControlName="name" class="pointer-events-none" />
      </div>
      <div>
        <label for="mail">Mail</label>
        <input id="mail" readonly type="email" formControlName="mail" class="pointer-events-none" />
      </div>
      <div>
        @if (exerciseTypes$ | async; as exerciseTypes ) {
          <label for="exercise-type">Tipologia dipendente</label>
          <select id="exercise-type" formControlName="exercise_type_id">
            <option value="" disabled hidden>Seleziona la tipologia dipendente</option>
            @for (et of exerciseTypes; track et.id) {
              <option [ngValue]="+et.id">
                {{et.label}}
              </option>
            }
          </select>
        }
      </div>



      <div>
        @if(filteredRequestTypes$ | async; as requestTypes) {
        <label for="request-type">Tipo di richiesta</label>
          <select id="request-type" formControlName="request_type_id" (change)="onRequestTypeChange($event,requestTypes )">
            <option value="" disabled hidden>Seleziona il tipo richiesta</option>
            @for(rt of requestTypes; track rt.id) {
              <option  [value]="+rt.id">
                {{rt.label}}
              </option>
            }
          </select>

        }
      </div>
      @if(requestTypeDescription) {
        <div class="w-full bg-gray-300 p-2 rounded-md">
          <div [innerHTML]="requestTypeDescription"></div>
        </div>
      }
      <div>
        <label for="notes">Richiesta</label>
        <textarea id="notes" type="text" formControlName="notes" rows="10"></textarea>
      </div>

      <div>
        <label for="attachments">Allegati</label>
        <input type="file" class="cursor-pointer" id="attachments" multiple (change)="onFileSelected($event)"  formControlName="attachments" #fileInput/>
      </div>

      <div class="flex justify-end">
        <button type="submit" [disabled]="requestForm.invalid || submitted()"
                class="button primary">Invia</button>
      </div>
      <p class="py-6">
        {{result}}
      </p>

      <div>
        <div>
          @if(submitted()) {
            <button type="button" class="button primary" (click)="newRequest()">Nuova richiesta</button>
          }
        </div>
      </div>
    </form>
  </div>
</div>
